import React, { useMemo } from "react";
import { IVisitsByProperty, VisitsPropertyFilter } from "../types/ownerDashboard.types";
import { getPropertyFilterLabel } from "../utils/getPropertyFilterLabel";
import DashboardSelect from "../components/DashboardSelect";
import { RentedPropertyCatalog } from "../utils/buildRentedPropertyCatalog";
import { enrichPropertyFilterLabel } from "../utils/rentedPropertyDisplay";

interface PropertyFilterProps {
  properties: IVisitsByProperty[];
  selectedProperty: VisitsPropertyFilter;
  onSelectProperty: (propertyId: VisitsPropertyFilter) => void;
  rentedPropertyCatalog?: RentedPropertyCatalog;
}

export default function PropertyFilter({
  properties,
  selectedProperty,
  onSelectProperty,
  rentedPropertyCatalog,
}: PropertyFilterProps) {
  const options = useMemo(
    () => [
      { value: "all", label: "Todos os imóveis" },
      ...properties.map((property) => ({
        value: String(property.property_id),
        label: enrichPropertyFilterLabel(
          getPropertyFilterLabel(property),
          rentedPropertyCatalog?.findByPropertyId(property.property_id)
        ),
      })),
    ],
    [properties, rentedPropertyCatalog]
  );

  if (properties.length === 0) {
    return null;
  }

  const selectValue = selectedProperty === "all" ? "all" : String(selectedProperty);

  return (
    <DashboardSelect
      label="Filtrar por imóvel"
      value={selectValue}
      options={options}
      onChange={(value) => onSelectProperty(value === "all" ? "all" : Number(value))}
    />
  );
}
